import gen from '../gen'
import firebase from 'firebase/app'
import 'firebase/auth';
import {
  newUserAccountSetup
} from '../../../api'
import axios from 'axios'
import router from '../../../router'

const state = {

}

const getters = {

}

const mutations = {
  //
  async googleLogin(state){
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // ...
      let uid = user.uid
      // ...
      /*axios.get(newUserAccountSetup, {
        params: {
          uid
        }
      }).then((response)=>{
        //
        console.log(`response google login: `, response)
        //gen.mutations.goTo(state, '/')
       // if(localStorage.getItem('to').name !== 'null'
         // || JSON.parse(localStorage.getItem('to')).name !== null) {
          router.go(-1)
       // }
        //
      })*/
      //
      router.go(-1)
     // localStorage.setItem('uploader', JSON.stringify({"uploader":"user","uploaderId":uid}))
      //
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      alert(errorMessage)

     /* gen.mutations.snackbar_alert(state, {
        msg: error.message
      }) */

      // ...
    });
  },
  fbLogin(state){
    console.log(`calling fb login`)
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // ...
      let uid = user.uid
      // ...
      /*axios.get(newUserAccountSetup, {
        params: {
          uid
        }
      }).then((response)=>{
        //
        console.log(`response google login: `, response)
        //gen.mutations.goTo(state, '/')
        router.go(-1)
        //
      })*/
      //
      router.go(-1)
      //
    }).catch(function(error) {
      //
      console.log(`fb login err: `, error)
      //
      console.log(`error msg: `, error.message)
      //
      gen.mutations.snackbar_alert(state, {
        msg: error.message
      })
      //
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });


    /* firebase.auth().getRedirectResult().then(function(result) {
      if (result.credential) {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        var token = result.credential.accessToken;
        // ...
        var user = result.user;
        // ...
        console.log(`user: `, user)
        let uid = user.uid
        // ...
        axios.get(newUserAccountSetup, {
          params: {
            uid
          }
        }).then((response)=>{
          //
          console.log(`response google login: `, response)
          //gen.mutations.goTo(state, '/')
          router.go(-1)
          //
        })
      }
      // The signed-in user info.
      var user = result.user;
    }).catch(function(error) {
      console.log('fb login err: ', error)
      // Handle Errors here.

      gen.mutations.snackbar_alert(state, {
        msg: error.message
      })

      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    }); */

  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/socialMedia.js